import React, { useState, useRef } from 'react';
import { FormControl, Button } from 'react-bootstrap';
import { FiUpload,FiArrowRight } from 'react-icons/fi';
import * as constants from '../Data';
import { useNavigate } from "react-router-dom";

function AssemblyInputBox({ clientConfigs }) {
  const [entryId, setEntryId] = useState('');
  const fileInputRef = useRef(null);
  const navigate = useNavigate();

  const onFileButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleSubmitFile = (event) => {
    event.preventDefault();
    if (fileInputRef.current.files.length > 0) {
      const fileToUpload = fileInputRef.current.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        if (fileToUpload.name !== "") {
          const fileName = fileToUpload.name.toLowerCase();

          // drop base64 metadata and pad message
          let encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
          if ((encoded.length % 4) > 0) {
            encoded += '='.repeat(4 - (encoded.length % 4));
          }
          const data = {
            data: encoded,
            fileName: fileName,
            skipEvolAnalysis: clientConfigs.skipEvolAnalysis,
            email: null
          };

          fetch(clientConfigs.eppicApiServerBaseUrl + constants.FILE_UPLOAD_END_POINT, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(data)
          })
              .then(response => {
                if (!response.ok) {
                  response.text().then(errorMessage => {
                    alert(errorMessage);
                  })
                } else {
                  return response.json();
                }
              })
              .then(items => {
                if (items != null) {
                  navigate(`/${constants.TAB_ASSEMBLIES}/` + items.submissionId);
                }
              })
              .catch(error => {
                fileInputRef.current.value = null;
                alert('Failed to fetch: ' + error.message);
              })
              .finally(() => {
                fileInputRef.current.value = null;
              });
        }
      }
      reader.readAsDataURL(fileToUpload);
    }
  };

  const handleSubmitEntryId = (e) => {
    e.preventDefault();
    navigate(`/${constants.TAB_ASSEMBLIES}/` + entryId);
    setEntryId('');
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSubmitEntryId(e);
    }
  };

  return (
    <div style={{ backgroundColor: '#fafafa', borderBottom: '0.5px solid #d4d4d4',width: '100%' }}>
      <div style={{ display: 'flex', alignItems: 'center',marginTop:'10px',marginBottom:'10px' }}>
        <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
          <FormControl
            aria-label="Text input for PDB ID"
            placeholder="Enter PDB ID"
            value={entryId}
            onChange={(e) => setEntryId(e.target.value)}
            onKeyDown={handleKeyPress}
            style={{ 
              borderRadius: '20px', 
              width: '250px',
              marginLeft:'20px',
              backgroundColor: '#fafafa',
              outline: 'none',
              color: 'black',
              paddingLeft: '15px',
              paddingRight: '35px'
            }}
            onFocus={(e) => {
              e.target.style.boxShadow = '0 0 0 0rem rgba(128, 128, 128, 0.25)';
              e.target.style.borderColor = 'gray';
            }}
            onBlur={(e) => {
              e.target.style.boxShadow = 'none';
              e.target.style.borderColor = '';
            }}
          />
          {entryId && (
            <Button
              variant="dark"
              onClick={handleSubmitEntryId}
              style={{
                position: 'absolute',
                right: '5px',
                borderRadius: '50%',
                width: '30px',
                height: '30px',
                padding: '0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <FiArrowRight color="white" />
            </Button>
          )}
        </div>
        <span style={{ margin: '0 20px', fontWeight: 'bold' }}>or</span>
        <Button
          variant="outline-secondary"
          onClick={onFileButtonClick}
          style={{
            borderRadius: '20px',
            whiteSpace: 'nowrap',
            width: '250px',
            borderColor: '#d4d4d4',
            boxShadow: 'none',
            color: '#6c757d',
            backgroundColor: '#fafafa',
            ':hover': {
              boxShadow: 'none',
              backgroundColor: '#fafafa',
              color: '#6c757d',
            },
            ':active': {
              boxShadow: 'none',
              backgroundColor: '#fafafa',
              color: '#6c757d',
            }
          }}
        >
          <FiUpload style={{ color: 'inherit' }} /> Upload File
        </Button>
        <FormControl
          type="file"
          ref={fileInputRef}
          onChange={handleSubmitFile}
          style={{ display: 'none' }}
        />
      </div>
    </div>
  );
}

export default AssemblyInputBox;